import type { Module } from '@pc/core';
import { appBus } from '@pc/core';
import { getWholesalerSummary, probeSchemaIsExposed } from '@pc/db';
import { lazyWithReload } from '@pc/ui';
import './events';

const WholesalersListPage = lazyWithReload(
  () => import('./pages/WholesalersListPage'),
);
const WholesalerDetailPage = lazyWithReload(
  () => import('./pages/WholesalerDetailPage'),
);
const WholesalerNewPage = lazyWithReload(() => import('./pages/WholesalerNewPage'));
const WholesalerCustomerDetailPage = lazyWithReload(
  () => import('./pages/WholesalerCustomerDetailPage'),
);
const WholesalersDashboardWidget = lazyWithReload(
  () => import('./widgets/WholesalersDashboardWidget'),
);

export const wholesalersModule: Module = {
  id: 'wholesalers',
  name: 'Wholesalers',
  description:
    'B2B accounts with tax IDs, resale certs, payment terms, credit limits, and tier pricing. On Pro and up.',
  basePath: '/wholesalers',
  routes: [
    { path: '/', element: <WholesalersListPage /> },
    { path: '/new', element: <WholesalerNewPage /> },
    { path: '/:id', element: <WholesalerDetailPage /> },
    {
      path: '/:id/customers/:customerId',
      element: <WholesalerCustomerDetailPage />,
    },
  ],
  navItems: [{ label: 'Wholesalers', to: '/wholesalers', order: 20 }],
  dashboardWidgets: [
    {
      id: 'recent-wholesalers',
      span: 1,
      order: 25,
      render: WholesalersDashboardWidget,
    },
  ],
  events: {
    publishes: ['wholesaler.created', 'wholesaler.updated', 'wholesaler.archived'],
    subscribesTo: {
      'wholesaler.created': (payload) => {
        appBus().emit('app.toast', {
          text: `New wholesaler: ${payload.companyName}`,
          tone: 'success',
        });
      },
    },
  },
  publicApi: {
    /** Look up a wholesaler through the stable v_wholesaler_summary view. */
    getWholesalerSummary: getWholesalerSummary as unknown as (...args: never[]) => unknown,
  },
  healthProbe: () => probeSchemaIsExposed('wholesalers', 'v_wholesaler_summary'),
};
